import * as React from 'react';

import { SortableTable } from '@coursera/coursera-ui';

import type { Program, UserRoster } from 'bundles/enterprise-admin-users/types';
import { getFormattedContractType, renderUSDate } from 'bundles/enterprise-admin-users/utils';

import _t from 'i18n!nls/enterprise-admin-users';

type ContractTableProps = {
  userRosters: UserRoster[];
};

export const SimpleContractTable = ({ userRosters }: ContractTableProps) => {
  const rows = userRosters.map((roster) => {
    const { contract } = roster;
    const utilization = contract && contract.utilization;
    return {
      key: contract && contract.id,
      name: contract && (contract.name || contract.id),
      type: getFormattedContractType(contract && contract.limitType),
      remaining: utilization && utilization.remaining,
      started: contract && contract.startsAt,
      ends: contract && contract.endsAt,
    };
  });
  return (
    <SortableTable
      columns={[
        {
          accessor: 'name',
          header: _t('Name'),
        },
        {
          accessor: 'type',
          header: _t('Contract Type'),
        },
        {
          accessor: 'remaining',
          header: _t('Remaining'),
        },
        {
          accessor: 'started',
          header: _t('Started'),
          cellRenderer: renderUSDate,
        },
        {
          accessor: 'ends',
          header: _t('Ends'),
          cellRenderer: renderUSDate,
        },
      ]}
      rows={rows}
    />
  );
};

type ProgramTableProps = {
  programs: Program[];
};

export const SimpleProgramTable = ({ programs }: ProgramTableProps) => {
  const rows = programs.map((program) => ({
    key: program.id,
    name: program.metadata.name,
  }));
  return (
    <SortableTable
      columns={[
        {
          accessor: 'name',
          header: _t('Name'),
        },
      ]}
      rows={rows}
      data-testid="programs-table"
    />
  );
};
